import { baseURL } from './baseUrl';
import { apiFilterProducts } from './apiMultiFilter';

export const apiGetDesigns = async (
    mainCategory: string,
    applicationName: string,
    collectionName: string
) => {
    const response = await baseURL.get(
        `get-designs-by-cat-application-range?cat=${mainCategory}&application=${applicationName}&range=${collectionName}&start=0&count=10`
    );
    return response.data;
};

// Same endpoint as the listing grid — go through apiFilterProducts so an
// identical body isn't sent twice.
export const apiGetDesignsInCollection = (filters: object) => apiFilterProducts(filters);
